import React from "react";
import { AnimatePresence, motion } from "framer-motion";

export const IncompatiblePackageModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <AnimatePresence>
      {isOpen && (
        <>
          {/* Overlay */}
          <motion.div
            className="fixed inset-0 bg-[#060f23] z-50"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
          />
          {/* Modal content */}
          <motion.div
            className="fixed inset-0 flex items-center justify-center z-50"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <div className="bg-[#030711] rounded-[24px] shadow-[0px_0px_16px_4px_rgba(6,14,35,0.08),0px_0px_0px_1px_rgba(6,14,35,0.04),0px_16px_24px_-12px_rgba(6,14,35,0.16)] w-[700px] h-[381px] p-6 relative">
              {/* Content */}
              <div className="flex flex-col items-center justify-center text-center h-full pb-[80px]">
                <h1 className="text-[29px] font-bold text-[#E6ECFF] leading-[37px] tracking-[-0.01em] mb-4">
                  Incompatible Package
                </h1>
                <p className="text-[16px] font-medium text-[#C6CCE8] leading-[22px] max-w-[482px]">
                  This package is not compatible with this mode. Switch modes
                  and scan the package again to continue.
                </p>
              </div>

              {/* Button */}
              <div className="absolute bottom-6 left-6 right-6">
                <button
                  onClick={onClose}
                  className="w-full h-[80px] bg-[#173991] text-white rounded-xl text-[21px] font-bold hover:bg-[#2256DB] shadow-[0px_1px_2px_0px_rgba(0,0,0,0.08),inset_0px_-1px_1px_0px_rgba(0,0,0,0.16)]"
                >
                  Okay
                </button>
              </div>
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};
